/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpRespContainerNotListed_user = {|
  +serviceId: ?string;
  +favorites?: ?{| |};
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "favoritePages",
      "type": "[String]"
    },
    {
      "kind": "RootArgument",
      "name": "fetchFavorites",
      "type": "Boolean"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespContainerNotListed_user",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsGrid_user",
      "args": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "serviceId",
      "storageKey": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchFavorites",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 1,
              "type": "Int"
            },
            {
              "kind": "Variable",
              "name": "pages",
              "variableName": "favoritePages",
              "type": "[String]"
            },
            {
              "kind": "Literal",
              "name": "types",
              "value": [
                "SEARCH"
              ],
              "type": "[types]"
            }
          ],
          "concreteType": "favoritesConnection",
          "name": "favorites",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "FollowSearchButton_favoritesConnection",
              "args": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "User"
};

module.exports = fragment;
